module.exports = __webpack_public_path__ + "static/media/pic5.34d75083.jpg";